
      var _path, _rect, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOtp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 81,
  height: 80,
  viewBox: "0 0 81 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M54.096 27.39V13.142a5 5 0 0 0-5-5H19.273a5 5 0 0 0-5 5V66.86a5 5 0 0 0 5 5h29.823a5 5 0 0 0 5-5v-9.036",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 38.167,
  y: 16.77,
  width: 7.965,
  height: 2.92,
  rx: 1.46,
  transform: "rotate(-180 38.167 16.77)",
  fill: "url(#otp_ba2107c76e413eb2__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M61.065 32.46H31.903a4.667 4.667 0 0 0-4.667 4.668V48.18a4.667 4.667 0 0 0 4.667 4.666h1.218c.736 0 1.333.597 1.333 1.334v3.748c0 .962 1.195 1.443 1.894.763l5.623-5.467c.25-.242.583-.377.93-.377h18.164a4.667 4.667 0 0 0 4.666-4.667V37.128a4.667 4.667 0 0 0-4.666-4.667Z",
  stroke: "#000",
  strokeWidth: 1.5
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.41 42.37c-1.975.464-2.323.84-2.751 2.98-.429-2.14-.776-2.517-2.752-2.98 1.975-.465 2.323-.841 2.751-2.982.43 2.14.776 2.517 2.752 2.981Z",
  fill: "url(#otp_ba2107c76e413eb2__b)",
  stroke: "url(#otp_ba2107c76e413eb2__c)",
  strokeWidth: 0.5,
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M49.247 42.37c-1.975.464-2.323.84-2.752 2.98-.428-2.14-.776-2.517-2.751-2.98 1.975-.465 2.323-.841 2.75-2.982.43 2.14.778 2.517 2.753 2.981Z",
  fill: "url(#otp_ba2107c76e413eb2__d)",
  stroke: "url(#otp_ba2107c76e413eb2__e)",
  strokeWidth: 0.5,
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M60.083 42.37c-1.975.464-2.323.84-2.752 2.98-.428-2.14-.776-2.517-2.751-2.98 1.975-.465 2.323-.841 2.75-2.982.43 2.14.777 2.517 2.752 2.981Z",
  fill: "url(#otp_ba2107c76e413eb2__f)",
  stroke: "url(#otp_ba2107c76e413eb2__g)",
  strokeWidth: 0.5,
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "otp_ba2107c76e413eb2__a",
  x1: 42.149,
  y1: 16.77,
  x2: 42.149,
  y2: 19.691,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "otp_ba2107c76e413eb2__b",
  x1: 35.659,
  y1: 39.388,
  x2: 35.659,
  y2: 45.35,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "otp_ba2107c76e413eb2__c",
  x1: 35.659,
  y1: 39.388,
  x2: 35.659,
  y2: 45.35,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "otp_ba2107c76e413eb2__d",
  x1: 46.495,
  y1: 39.388,
  x2: 46.495,
  y2: 45.35,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "otp_ba2107c76e413eb2__e",
  x1: 46.495,
  y1: 39.388,
  x2: 46.495,
  y2: 45.35,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "otp_ba2107c76e413eb2__f",
  x1: 57.331,
  y1: 39.388,
  x2: 57.331,
  y2: 45.35,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "otp_ba2107c76e413eb2__g",
  x1: 57.331,
  y1: 39.388,
  x2: 57.331,
  y2: 45.35,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})))));

      const __svgRaw = "<svg width=\"81\" height=\"80\" viewBox=\"0 0 81 80\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M54.0957 27.3899L54.0957 13.1423C54.0957 10.3809 51.8571 8.14233 49.0957 8.14233L19.2731 8.14233C16.5117 8.14233 14.2731 10.3809 14.2731 13.1423L14.2731 56.4959L14.2731 66.8585C14.2731 69.6199 16.5117 71.8585 19.2731 71.8585L30.8659 71.8585L49.0957 71.8585C51.8571 71.8585 54.0957 69.6199 54.0957 66.8585L54.0957 57.8233\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<rect x=\"38.1667\" y=\"16.7705\" width=\"7.96452\" height=\"2.92032\" rx=\"1.46016\" transform=\"rotate(-180 38.1667 16.7705)\" fill=\"url(#paint0_linear_8631_157280)\"/>\r\n<path d=\"M61.0647 32.4609H31.9029C29.3255 32.4609 27.2362 34.5503 27.2362 37.1276V48.1798C27.2362 50.7571 29.3255 52.8465 31.9029 52.8465H33.1207C33.8571 52.8465 34.454 53.4434 34.454 54.1798V57.9284C34.454 58.8895 35.6491 59.3708 36.3481 58.6912L41.9712 53.2238C42.2201 52.9818 42.5535 52.8465 42.9007 52.8465H61.0647C63.642 52.8465 65.7314 50.7571 65.7314 48.1798V37.1276C65.7314 34.5503 63.642 32.4609 61.0647 32.4609Z\" stroke=\"black\" stroke-width=\"1.5\"/>\r\n<path d=\"M38.4103 42.3692C36.4349 42.8338 36.0872 43.2101 35.6588 45.35C35.23 43.2096 34.8828 42.8333 32.9073 42.3692C34.8822 41.9051 35.23 41.5288 35.6583 39.3884C36.0872 41.5288 36.4344 41.9051 38.4098 42.3692H38.4103Z\" fill=\"url(#paint1_linear_8631_157280)\" stroke=\"url(#paint2_linear_8631_157280)\" stroke-width=\"0.5\" stroke-linejoin=\"round\"/>\r\n<path d=\"M49.247 42.3692C47.2715 42.8338 46.9238 43.2101 46.4955 45.35C46.0666 43.2096 45.7194 42.8333 43.744 42.3692C45.7189 41.9051 46.0666 41.5288 46.4949 39.3884C46.9238 41.5288 47.2715 41.9051 49.247 42.3692Z\" fill=\"url(#paint3_linear_8631_157280)\" stroke=\"url(#paint4_linear_8631_157280)\" stroke-width=\"0.5\" stroke-linejoin=\"round\"/>\r\n<path d=\"M60.0829 42.3692C58.1075 42.8338 57.7597 43.2101 57.3314 45.35C56.9026 43.2096 56.5553 42.8333 54.5799 42.3692C56.5548 41.9051 56.9026 41.5288 57.3309 39.3884C57.7597 41.5288 58.107 41.9051 60.0824 42.3692H60.0829Z\" fill=\"url(#paint5_linear_8631_157280)\" stroke=\"url(#paint6_linear_8631_157280)\" stroke-width=\"0.5\" stroke-linejoin=\"round\"/>\r\n<defs>\r\n<linearGradient id=\"paint0_linear_8631_157280\" x1=\"42.1489\" y1=\"16.7705\" x2=\"42.1489\" y2=\"19.6908\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint1_linear_8631_157280\" x1=\"35.6588\" y1=\"39.3884\" x2=\"35.6588\" y2=\"45.35\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint2_linear_8631_157280\" x1=\"35.6588\" y1=\"39.3884\" x2=\"35.6588\" y2=\"45.35\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint3_linear_8631_157280\" x1=\"46.4955\" y1=\"39.3884\" x2=\"46.4955\" y2=\"45.35\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint4_linear_8631_157280\" x1=\"46.4955\" y1=\"39.3884\" x2=\"46.4955\" y2=\"45.35\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint5_linear_8631_157280\" x1=\"57.3314\" y1=\"39.3884\" x2=\"57.3314\" y2=\"45.35\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint6_linear_8631_157280\" x1=\"57.3314\" y1=\"39.3884\" x2=\"57.3314\" y2=\"45.35\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/otp.ba2107c76e413eb282525ae1295bc6a5.svg"),
        {
          React: SvgOtp,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      